interface TestimonialCardProps {
  quote: string;
  author: string;
  role: string;
  gradient: string;
  initials: string;
}

export default function TestimonialCard({ quote, author, role, gradient, initials }: TestimonialCardProps) {
  return (
    <div className="testimonial-card card">
      <blockquote className="testimonial-card__quote">
        <span className="testimonial-card__quote-mark" aria-hidden="true">
          &ldquo;
        </span>
        <em>{quote}</em>
      </blockquote>
      <div className="testimonial-card__author">
        <div
          className="testimonial-card__avatar"
          style={{ background: gradient }}
          aria-hidden="true"
        >
          {initials}
        </div>
        <div className="testimonial-card__info">
          <p className="testimonial-card__name body-bold">{author}</p>
          <p className="testimonial-card__role caption">{role}</p>
        </div>
      </div>
    </div>
  );
}
